import { Component, Input, OnInit } from '@angular/core';
import { Element } from '../element';

@Component({
    selector: 'chassis-core-label',
    templateUrl: './label.component.html',
    styleUrls: ['./label.component.scss']
})
export class LabelComponent extends Element implements OnInit {
    @Input() entity;

    ngOnInit() {
    }

    public get showAsterisk() {
        // TODO: check for page mode(detail/input) and for creationRules on create page and for updateRules on update page

        if (this.data.hasOwnProperty('rules') && this.data.rules.includes('required')) {
            return true;
        }

        if (this.entity && this.entity.hasOwnProperty('id')) {
            if (this.data.hasOwnProperty('updateRules') && this.data.updateRules.includes('required')) {
                return true;
            }
        } else if (this.entity && !this.entity.hasOwnProperty('id')) {
            if (this.data.hasOwnProperty('creationRules') && this.data.creationRules.includes('required')) {
                return true;
            }
        }

        return false;
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/resources/components/elements/label/label.component.ts